export default "__VITE_ASSET__6f38af66__"